module.exports = __webpack_public_path__ + "static/media/ftu-add-workout.3ce31045.png";